// extracted by mini-css-extract-plugin
module.exports = {"dots":"readMore_dots__I5bCQ","more":"readMore_more__MyDh0","readMore":"readMore_readMore__f81Tg"};